module.exports = __webpack_public_path__ + "img/plus.ee8a427b.svg";